import React, { useContext } from 'react';
import { Box, Card, CardBody, CardFooter, ThemeContext, Text } from 'grommet';

export const ChartCard = ({ title, subtitle, children, footer, onClick, style, ...rest }) => {
  const theme = useContext(ThemeContext);
  const isDarkMode = theme.dark;

  const baseBg = isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)';
  const hoverBg = isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.6)';

  return (
    <Card 
      onClick={onClick}
      style={{
        backgroundColor: baseBg,
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.4)'}`,
        borderRadius: '16px',
        transition: 'all 0.2s ease-in-out',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'scale(1.015)';
          e.currentTarget.style.backgroundColor = hoverBg;
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.backgroundColor = baseBg;
        }
      }}
      {...rest}
    >
      {/* HEADER: Mirrored from ListResults logic */}
      <Box pad="medium" gap="xxsmall">
        <Text weight="bold" color="text-strong" size="large">
          {title}
        </Text>
        {subtitle && (
          <Text size="small" color="text-weak">
            {subtitle}
          </Text>
        )}
      </Box>

      <CardBody pad={{ horizontal: 'medium', bottom: 'medium' }}>
        {children}
      </CardBody>
      
      {footer && (
        <CardFooter 
          pad="small" 
          border={{ 
            side: 'top', 
            color: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)' 
          }}
        >
          {footer}
        </CardFooter>
      )}
    </Card>
  );
};